export default function WhyAlphadenSection() {
    const values = [
      {
        icon: "P",
        title: "People First",
        description: "We invest in talent, training, and safety above all.",
        color: "bg-[#E8151C]"
      },
      {
        icon: "I",
        title: "Integrity",
        description: "Transparency and accountability drive our operations.",
        color: "bg-[#E8151C]"
      },
      {
        icon: "I",
        title: "Innovation",
        description: "Advanced technologies to maximize uptime and output.",
        color: "bg-[#E8151C]"
      },
      {
        icon: "E",
        title: "Efficiency",
        description: "Every system is designed to reduce cost, time, and complexity.",
        color: "bg-[#E8151C]"
      }
    ];
  
    return (
      <section className="relative bg-gray-50 py-[100px] overflow-hidden">
         <div className="absolute bottom-0 right-0  z-10">
            <img src="https://res.cloudinary.com/dpkn1ppzj/image/upload/v1763713514/image_28_2_vvy4gr.png" alt="Why Alphaden Section Background" className="w-[277px] h-[230px] object-cover object-center" />
        </div>
        <div className="max-w-[1160px] mx-auto px-6 sm:px-8 lg:px-12 relative z-10">
          {/* Section Header */}
          <div className="text-center mb-[40px]">
            <span className="text-[#E37D33] font-medium text-lg ">
              Why Alphaden
            </span>
            <h2 className="text-3xl sm:text-[42px] font-medium text-[#010305] my-4 leading-tight">
              Why operators <br /> choose us
            </h2>
            <p className="text-lg text-[#677078] leading-relaxed max-w-2xl mx-auto">
              Our approach is built on the values that shape every project, every partnership, and every deployment:
            </p>
          </div>
  
          {/* Values Grid */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-4">
            {values.map((value, index) => (
              <div 
                key={index}
                className="bg-white rounded-[12px] py-[14px] px-[12px] shadow-sm hover:shadow-lg transition-all duration-300 group"
              >
                {/* Icon */}
                <div className={`${value.color} w-[28px] h-[28px] rounded-full flex items-center justify-center mb-2 group-hover:scale-110 transition-transform duration-300`}>
                  <span className="text-white font-bold text-xl">
                    {value.icon}
                  </span>
                </div>
  
                {/* Title */}
                <h3 className="text-xl font-semibold text-[#010305] mb-4">
                  {value.title}
                </h3>
  
                {/* Description */}
                <p className="text-gray-600 text-sm leading-relaxed">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
  
        {/* Optional: Decorative background blur */}
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-100 rounded-full blur-3xl opacity-20 pointer-events-none" />
      </section>
    );
  }